import { Component, Input } from '@angular/core';
import { steps } from '../organization-add-cartridges-dialog/organization-add-cartridges-dialog.component';

@Component({
  selector: 'markant-platform-organization-add-cartridges-stepper',
  templateUrl: './organization-add-cartridges-stepper.component.html',
  styleUrls: ['./organization-add-cartridges-stepper.component.scss'],
})
export class OrganizationAddCartridgesStepperComponent {
  protected readonly steps = steps;

  @Input() currentStep: steps = steps.CartridgeSelection;
}
